import {
  createSlice,
  createEntityAdapter,
  EntityState,
  PayloadAction,
} from '@reduxjs/toolkit'
import { getPayments } from './api'
import { PaymentMethod } from './typings'
import { StoreData } from '../reducers/typings'

const paymentAdapter = createEntityAdapter<PaymentMethod>()
type PaymentsState = EntityState<PaymentMethod>

export const initialState: PaymentsState = paymentAdapter.getInitialState()

export const paymentsSlice = createSlice({
  name: 'payments',
  initialState,
  reducers: {
    addPaymentMethod: (state, { payload }: PayloadAction<PaymentMethod>) => {
      paymentAdapter.addOne(state, payload)
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getPayments.fulfilled, (state, { payload }) => {
      paymentAdapter.upsertMany(state, payload)
    }),
      builder.addCase(getPayments.pending, (state) => {
        paymentAdapter.removeAll(state)
      })
  },
})

export default paymentsSlice.reducer

// SELECTORS
export const paymentSelectors = paymentAdapter.getSelectors<StoreData>(
  (state) => state.payments,
)

export const { selectById: selectPaymentById, selectAll: selectAllPayments } =
  paymentSelectors

// ACTIONS
export const { addPaymentMethod } = paymentsSlice.actions
